const selectProfileL18n = {
	'selectProfile.prefix': 'HOLA',
	'selectProfile.title': '¿Para quién es la cita?',
};

export default selectProfileL18n;
